import axios from "axios";
import { baseUrl } from "../utils/constant";

let setLoading;

export const setGlobalLoading = (loadingSetter) => {
	setLoading = loadingSetter;
};

const fetchData = async (url) => {
	if (setLoading) setLoading(true);

	try {
		const response = await axios.get(url);
		return response;
	} catch (error) {
		console.error("Error fetching data:", error);
		throw error;
	} finally {
		if (setLoading) setLoading(false);
	}
};

export const getRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/remittance/transaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getGmgRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/remittance/gmgtransaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getMustaqbalRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/remittance/mustaqbaltransaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getTerraPayRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/remittance/terrapaytransaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getImportRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/import-remittance/transaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getRefundRemittanceReportData = (remittanceNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/remittance/Refundtransaction?transctionNumber=${remittanceNumber}&lang=${lang}`
	);

export const getExchangeTransaction = (transactionNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/exchange/transaction?transctionNumber=${transactionNumber}&lang=${lang}`
	);

export const getBulkExchangeTransaction = (transactionNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/exchange/transaction?transctionNumber=${transactionNumber}&lang=${lang}`
	);

export const getAgentExchangeRequest = (requestNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/exchange/request?requestNumber=${requestNumber}&lang=${lang}`
	);

export const getAuctionExchangeRequest = (requestNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/auction/request?requestNumber=${requestNumber}&lang=${lang}`
	);

export const getCashTransaction = (transactionNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/cash/transaction?transctionNumber=${transactionNumber}&lang=${lang}`
	);

export const getInternalCashMoveData = (cashmoveid, lang) =>
	fetchData(
		`${baseUrl}/receipt/cashmove/transaction?transctionNumber=${cashmoveid}&lang=${lang}`
	);

export const getInternalCashReconciliationReportData = (cashmoveid, lang) =>
	fetchData(
		`${baseUrl}/receipt/casherconciliation?transctionNumber=${cashmoveid}&lang=${lang}`
	);

export const getTransactionReversalData = (cashmoveid, lang) =>
	fetchData(
		`${baseUrl}/receipt/transactionreversal?transctionNumber=${cashmoveid}&lang=${lang}`
	);

export const getGiftCardTransaction = (transactionNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/giftcard/transaction?transctionNumber=${transactionNumber}&lang=${lang}`
	);

export const getBulkSingleTransaction = (transactionNumber, lang) =>
	fetchData(
		`${baseUrl}/receipt/bulksingle/transaction?transctionNumber=${transactionNumber}&lang=${lang}`
	);

function getCookie(name) {
	var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
	return v ? v[2] : null;
}
